interface ToastMessage {
  variant?: "default" | "destructive";
  title?: string;
  description: string;
  duration?: number;
  closeOnClick?: boolean;
}

interface Messages {
  CREATE: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
  };
  UPDATE: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
    NO_CHANGES: ToastMessage;
  };
  DISABLED: {
    SUCCESS: ToastMessage;
    ERROR: ToastMessage;
  };
  EXCEL: {
    ERRORS_FOUND: (count: number) => ToastMessage;
    PROCESSING_ERROR: (message?: string) => ToastMessage;
    NO_CHANGES: ToastMessage;
    BATCH_SUCCESS: (
      updatedStores: number,
      createdRegionals: number
    ) => ToastMessage;
    CONFIRM_ERROR: (message?: string) => ToastMessage;
    DATA_ERROR: ToastMessage;
    AMBIGUITY_TITLE: (count: number) => string;
    AMBIGUITY_DESCRIPTION: (count: number) => string;
  };
  TEMPLATE: {
    DOWNLOAD_SUCCESS: ToastMessage;
    DOWNLOAD_ERROR: ToastMessage;
  };
}

export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Analistas atribuidos com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atribuir analistas.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Analistas atualizados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar analistas.",
      duration: 5000,
      closeOnClick: true,
    },
    NO_CHANGES: {
      variant: "default",
      title: "Nenhuma alteração",
      description: "Não há mudanças para salvar.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação!",
      duration: 5000,
      closeOnClick: true,
    },
  },
  EXCEL: {
    ERRORS_FOUND: (count: number) => ({
      variant: "destructive",
      title: "Arquivo com erros",
      description: `${count} ${
        count === 1 ? "erro encontrado" : "erros encontrados"
      }. Verifique o console para mais detalhes.`,
      duration: 5000,
      closeOnClick: true,
    }),
    PROCESSING_ERROR: (message?: string) => ({
      variant: "destructive",
      title: "Erro ao processar arquivo",
      description:
        message || "Verifique o formato do arquivo e tente novamente.",
      duration: 5000,
      closeOnClick: true,
    }),
    NO_CHANGES: {
      variant: "default",
      title: "Nenhuma alteração detectada",
      description: "Todas as lojas já estão com os regionais corretos.",
      duration: 5000,
      closeOnClick: true,
    },
    BATCH_SUCCESS: (updatedStores: number, createdRegionals: number) => ({
      variant: "default",
      title: "Sucesso!",
      description: `${updatedStores} ${
        updatedStores === 1 ? "loja atualizada" : "lojas atualizadas"
      }. ${createdRegionals} ${
        createdRegionals === 1 ? "regional criado" : "regionais criados"
      }.`,
      duration: 5000,
      closeOnClick: true,
    }),
    CONFIRM_ERROR: (message?: string) => ({
      variant: "destructive",
      title: "Erro ao confirmar atribuições",
      description:
        message || "Não foi possível salvar as alterações. Tente novamente.",
      duration: 5000,
      closeOnClick: true,
    }),
    DATA_ERROR: {
      variant: "destructive",
      title: "Erro de dados",
      description:
        "Não foi possível identificar o nome do regional selecionado. Recarregue a página e tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
    AMBIGUITY_TITLE: (_count: number) => "Resolver Ambiguidades",
    AMBIGUITY_DESCRIPTION: (count: number) =>
      `Encontramos ${count} ${
        count === 1 ? "ambiguidade" : "ambiguidades"
      } no arquivo. Por favor, escolha o regional correto para cada loja.`,
  },
  TEMPLATE: {
    DOWNLOAD_SUCCESS: {
      variant: "default",
      title: "Template baixado!",
      description: "Arquivo pronto para preenchimento.",
      duration: 5000,
      closeOnClick: true,
    },
    DOWNLOAD_ERROR: {
      variant: "destructive",
      title: "Erro ao baixar template",
      description: "Não foi possível gerar o arquivo. Tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};
